export default __webpack_public_path__ + "static/media/safe-recommendations--desktop.53097d60.webp";